// extracted by mini-css-extract-plugin
export default {"dataDetails":"data-details_dataDetails__vNnWe","detailsRow":"data-details_detailsRow__zdfOZ","unitsDetailsBlock":"data-details_unitsDetailsBlock__vFxPC"};